import styled from 'styled-components';

import Social from '@r1-frontend/ui-react/components/buttons/social';
import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

export const Footer = styled.div`
    display: block;
    width: 100%;
    background: ${COLORS.BgSecondary};
    padding: 40px 0;
    margin-top: 50px;

    @media (max-width: ${wideBreakpoints.tablet}) {
        padding: 32px 0 24px 0;
    }
`;

export const Wrap = styled.div`
    display: block;
    max-width: 1644px;
    padding: 0 8.4%;
    margin: 0 auto;

    @media (max-width: ${wideBreakpoints.sDesktop}) {
        padding: 0 5.3%;
    }

    @media (max-width: ${wideBreakpoints.mobile}) {
        padding: 0 16px;
    }
`;

export const FooterTop = styled.div`
    display: grid;
    grid-template-columns: repeat(2, auto);
    gap: 100px;

    @media (max-width: ${wideBreakpoints.laptop}) {
        display: block;
    }
`;

export const FooterSupport = styled.div`
    display: flex;
    flex-direction: column;
`;

export const Container = styled.div`
    display: block;
`;

export const SocialContainer = styled.div`
    display: flex;
    flex-direction: column;

    ul {
        display: flex;
        align-items: center;
        justify-content: flex-start;
    }

    li:not(:last-child) {
        margin-right: 8px;
    }

    a {
        width: 24px;
        height: 24px;
        opacity: 1;

        &:hover {
            background-color: ${COLORS.Outline_Light};
        }
    }

    @media (max-width: ${wideBreakpoints.mobile}) {
        display: block;
    }
`;

export const SocialText = styled.div`
    ${FONTS.XS};
    color: ${COLORS.GRAY_DARK};
    margin-bottom: 10px;

    @media (max-width: ${wideBreakpoints.mobile}) {
        margin: 0 0 8px 0;
    }
`;

export const SocialStyled = styled(Social)`
    li > a {
        @media (max-width: ${wideBreakpoints.mobile}) {
            width: 44px;
            height: 44px;
            padding: 5px;
        }
    }
    
    li > a > img {
        @media (max-width: ${wideBreakpoints.mobile}) {
            width: 44px;
            height: 44px;
            max-width: 100%;
            max-height: 100%;
        }
    }
`;

export const StoreButtons = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    grid-gap: 10px;
    margin-top: auto;

    a {
        padding: 10px 9px;
    }

    @media (max-width: ${wideBreakpoints.laptop}) {
        flex-direction: row;
        margin-top: 36px;
    }

    @media (max-width: ${wideBreakpoints.mobile}) {
        margin-top: 51px;
    }
`;

export const FooterService = styled.div`
    display: flex;
    flex-direction: column;
    gap: 73px;

    @media (max-width: ${wideBreakpoints.laptop}) {
        gap: 34px;
        margin-top: 34px;
    }
`;

export const LinksWrap = styled.div`
    display: flex;
    justify-content: space-between;
    position: relative;

    @media (max-width: ${wideBreakpoints.sDesktop}) {
        padding: 0;
        justify-content: flex-start;
        max-width: none;

        & > *:not(:last-child) {
            margin-right: 80px;
        }
    }

    @media (max-width: ${wideBreakpoints.mobile}) {
        & > *:not(:last-child) {
            margin-right: initial;
        }

        & > * {
            flex: 100% 1 0;
            margin-bottom: 16px;
        }

        & > *:nth-child(1),
        & > *:nth-child(2) {
            flex: 50% 1 0;
        }
    }
`;

export const Store = styled.div`
    display: flex;
    flex-wrap: nowrap;
    justify-content: space-between;
    align-items: flex-end;

    @media (max-width: ${wideBreakpoints.mobile}) {
        flex-direction: column;
        align-items: normal;
    }
`;

export const LogoContainer = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: center;
    justify-content: space-between;
    width: 343px;
    height: 90px;

    @media (max-width: ${wideBreakpoints.mobile}) {
        margin: 0 auto;
    }

    @media (max-width: 375px) {
        width: 288px;
        height: 64px;
    }
`;

export const LogoText = styled.div`
    max-width: 170px;
`;

export const LogoImage = styled.div`
    width: 144px;
    height: 100%;

    img {
        width: 100%;
        height: 100%;
        object-position: center;
        object-fit: cover;
    }

    @media (max-width: 375px) {
        width: 102px;
    }
`;

export const FooterBottom = styled.div`
    display: block;
    margin-top: 24px;
    border-top: 1px solid ${COLORS.GRAY_DARK};
`;

export const FooterText = styled.p`
    margin: 0;
    padding: 0 0 30px;
`;
